import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupNotification extends PopupBasic {
  private buttonOkay: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: 500,
      height: 760,
      darkerBg: false,
      tracking: { feature: 'popup', $subFeature: 'popup_notification' },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 600,
      x: 40,
      y: 55,
      zIndex: 1,
      align: 'left',
    });

    this.buttonOkay = new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      labelOffsetY: -1,
      fontSize: 31,
      font: 'Body',
      x: this.box.style.width / 2,
      y: this.box.style.height - 45 - 80 / 2,
      width: 259,
      height: 80,
      centerOnOrigin: true,
      onClick: async () => opts.close(),
      tracking: { feature: 'popup', $subFeature: 'popup_notification_ok' },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init(opts: { title: string; message: string; button?: string }) {
    super.init(opts);

    if (opts.button) {
      this.buttonOkay.localeText = () => opts.button!;
    } else {
      this.buttonOkay.localeText = () => i18n('basic.okay');
    }
  }
}
